module.exports = __webpack_public_path__ + "assets/img/李红.ba977071.jpg";